<div >
    <!--Super Admins' start page-->
    <div *ngIf="roleId === authService.ROLES.SUPER_ADMIN">
        <system-admin-component></system-admin-component>
    </div>

    <!--Admins' start page-->
    <div *ngIf="roleId === authService.ROLES.CLINIC_ADMIN">
        <clinic-admin-component></clinic-admin-component>
    </div>

    <!--B2C Admins' start page-->
    <div *ngIf="roleId === authService.ROLES.B2C_ADMIN">
        <b2c-admin-component></b2c-admin-component>
    </div>

    <!--Assitants' start page-->
    <div *ngIf="authService.EMPLOYEE_ROLES.indexOf(roleId) >= 0">
        <assistant-component></assistant-component>
    </div>

    <!--Patient' start page-->
    <div *ngIf="roleId === authService.ROLES.PATIENT">
        <patient-dashboard-component></patient-dashboard-component>
    </div>

    <!--INSURANCE_PARTNER' start page-->
    <div *ngIf="roleId === authService.ROLES.INSURANCE_PARTNER">
        <insurance-partner-component></insurance-partner-component>
    </div>
</div>